import { render, staticRenderFns } from "./DropdownManager.vue?vue&type=template&id=13735540&scoped=true"
import script from "./DropdownManager.vue?vue&type=script&lang=js"
export * from "./DropdownManager.vue?vue&type=script&lang=js"
import style0 from "./DropdownManager.vue?vue&type=style&index=0&id=13735540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13735540",
  null
  
)

export default component.exports